export function excludeFilterByKey<T extends Record<string, unknown>>(
  obj: T | undefined,
  keys: (keyof T)[],
): Partial<T> {
  if (!obj) return {};
  const clone: Partial<T> = { ...obj };
  keys.forEach((k) => {
    delete clone[k];
  });
  return clone;
}
